module.exports = __webpack_public_path__ + "static/media/slightRight.e6509f3c.svg";